import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 6.843h-9c-1.7 0-3 1.27-3 2.933v8.798c0 1.662 1.3 2.933 3 2.933h9c1.7 0 3-1.271 3-2.933V9.776c0-1.662-1.3-2.933-3-2.933m1 11.73c0 .587-.4.978-1 .978h-9c-.6 0-1-.39-1-.977V9.776c0-.587.4-.978 1-.978h9c.6 0 1 .391 1 .978zM4 12.709H3c-.6 0-1-.39-1-.977v-8.8c0-.586.4-.977 1-.977h9c.6 0 1 .39 1 .977v.978c0 .587.4.978 1 .978s1-.391 1-.978v-.977C15 1.271 13.7 0 12 0H3C1.3 0 0 1.27 0 2.933v8.798c0 1.662 1.3 2.933 3 2.933h1c.6 0 1-.392 1-.978 0-.587-.4-.977-1-.977"
    }, null, -1)
  ]))]))
}
export default { render: render }